/**
 * 用户管理配置接口
 * name：接口名称
 * url：接口api
 * method：接口请求方法，默认GET
 * defaultParams：默认参数
 */

export default [
  //  获取组织树节点信息
  {
    name: 'getNode',
    url: '/api/aam/v1/mgmt/groups/org-level/info'
  },

  //  设置组织树节点（覆盖）
  {
    name: 'putNode',
    url: '/api/aam/v1/mgmt/groups/org-level/info',
    method: 'PUT'
  },
  //  获取组织树节点功能权限（是否支持组织树新增组织、PC端与移动端权限关联）
  {
    name: 'getNodePermission',
    url: '/api/aam/v1/mgmt/groups/org-level/flag'
  },
  //  更新组织树节点功能权限（是否支持组织树新增组织、PC端与移动端权限关联）
  {
    name: 'putNodePermission',
    url: '/api/aam/v1/mgmt/groups/org-level/flag',
    method: 'PUT'
  },
  //  获取指定组织树节点的资源列表 orgLevel
  {
    name: 'getNodeAssoc',
    url: '/api/aam/v1/mgmt/groups/org-level/{@}/resources'
  },
  //  更新组织树节点关联的资源，返回组织树节点的资源 orgLevel
  {
    name: 'putNodeAssoc',
    url: '/api/aam/v1/mgmt/groups/org-level/{@}/resources',
    method: 'PUT'
  },
  // 获取模块管理配置相关内容
  {
    name: 'getNodeAttr',
    url: '/api/aam/v1/mgmt/groups/org-level/{@}/attribute',
    method: 'GET'
  },
  // 更新指定组织树节点下的自定义配置，例如拥有哪些模块，是否权限关联，权限关联内容orgLevel
  {
    name: 'putNodeAttr',
    url: '/api/aam/v1/mgmt/groups/org-level/{@}/attribute',
    method: 'PUT'
  },
  // 获取默认角色列表
  {
    name: 'getDefaultRole',
    url: '/api/aam/v1/mgmt/org/roles'
  },
  // 新增默认角色 orgLevel
  {
    name: 'addDefaultRole',
    url: '/api/aam/v1/mgmt/org/{@}/roles',
    method: 'POST'
  },
  // 修改默认角色 orgLevel  roleId
  {
    name: 'putDefaultRole',
    url: '/api/aam/v1/mgmt/org/{@}/roles/{@}',
    method: 'PUT'
  },
  // 获取自定义角色数据roleId
  // type:1 模块 2:权限关联
  {
    name: 'getRoleAttrs',
    url: '/api/aam/v1/mgmt/roles/{@}/attribute',
    method: 'GET'
  },
  //获取指定组织树节点下组织（机构）或部门的信息category orgLevel
  //groupType 机构类型，1：组织（机构），2：部门，默认为1。如果是1，则只返回机构，如果是2，返回机构和部门
  {
    name: 'getNodeOrgan',
    url: '/api/aam/v1/mgmt/groups/government/{@}/groups',
    method: 'GET'
  },
  // 获取当前用户管理范围的组织（包含所有角色的管理范围）
  {
    name: 'getOrganSelect',
    url: '/api/aam/v1/portal/user/scope/groups',
    method: 'GET'
  },
// 修改用户默认组织userId groupId
  {
    name: 'putDefaultOrgan',
    url: '/api/aam/v1/default/{@}/{@}',
    method: 'PUT'
  },
  // 修改默认角色 userId groupId roleId
  {
    name: "putDefauleRole",
    url: "/api/aam/v1/default/{@}/{@}/{@}",
    method: "PUT"
  },
]
